import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';

import Header from '@components/Header';
import JustificationModal from '@components/JustificationModal';

import { getProfilesCatalog, updateStatusProfile, deleteProfile } from '@actions/profiles';
import { setCatalogCurrentProfiles } from '@actions/catalogs';
import { validatePermissionAction } from '@actions/sessionPermission';
import { sendActionToBitacora  } from '@actions/bitacora';

import { getValueLanguageObj } from '@utils/general'

import {
  StatusVisible,
  LANGUAGE_DEFAULT
} from '@constants/general'
import { SET_CATALOG } from '@constants/actionType'
import catalogPermissionsId from '@constants/catalogPermissionsId';

import store from '@store'

import './style.scss'

const IS_EDIT = true
const ADMIN_GLOBAL_ID = 1

class Profiles extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPage: true,
      loadingTable: true,
      profiles: [],
      showModalJustification: {
        isVisible: false,
        title: '',
        description: '',
        label: '',
        continueAction: null,
      }
    };
  }

  componentDidMount() {
    this.loadData();
    return this.setState({loadingPage: false})
  }

  loadData = async (isEdit = false) => {
    const { getProfilesCatalog } = this.props;
    this.setState({ loadingTable: true });
    const params = {
      type: 'all'
    };

    const response = await getProfilesCatalog(params);
    if (!response?.status) {
      if (isEdit) this.setCatalagProfileUpdate(response.data)
      return this.setState({
        profiles: response.data,
        loadingTable: false,
      });
    }
    return this.setState({ loadingTable: false });
  };

  setCatalagProfileUpdate = async  (data) => {
    const { setCatalogCurrentProfiles } = this.props
    const getVisiblesProfiles = data.filter(item => item.estatus === 1)
    await store.dispatch({
      type: SET_CATALOG,
      payload: {nameCatalog: 'profileCatalog', data: getVisiblesProfiles || []}
    })
    setCatalogCurrentProfiles()
  }

  onConfirmDeleteProfile = (data) => {
    const { t } = this.props;
    this.setState({
      showModalJustification: {
        isVisible: true,
        title: t('CONFIRMACIÓN'),
        description: t('¿Esta seguro que desea eliminar {{ELEMENTO}}?', {ELEMENTO: getValueLanguageObj(data.nombre)}),
        label: t('Justificación de la eliminación'),
        continueAction: ({justification}) => this.onDeleteProfile(data, justification),
      },
    });
  }

  onDeleteProfile = async (data, justification) => {
    const { t, deleteProfile, sendActionToBitacora } = this.props;
    this.setState({loadingTable: true})
    const response = await deleteProfile({...data, justification});
    if (!response?.status) {
      const dataBitacora = {
        transactionName: 'bajaPerfil',
        reason: `${getValueLanguageObj(data.nombre, LANGUAGE_DEFAULT)} || ${justification}`,
      }
      await sendActionToBitacora(dataBitacora)
      await this.loadData(IS_EDIT);
      this.toast.show({
        severity: 'success',
        summary: t('Confirmación'),
        detail: t('La operación se ha realizado de manera éxitosa'),
        life: 3000,
      });
    }
    this.setState({loadingTable: false})
  };

  editProfile = (data) => {
    const { history } = this.props
    history.push({pathname: "/profile/edit", state: { ...data, clearCache: true }})
  }

  templateEdit = (node, detail) => {
    const { isFullAdmin } = this.props
    if (node.id === ADMIN_GLOBAL_ID && !isFullAdmin) return (
      <>
      <span className="p-column-title">{detail.header}</span>
      </>
    )
    return (
      <div>
        <span className="p-column-title">{detail.header}</span>
        <Button
          type="button"
          icon="pi pi-pencil"
          className="p-button-text"
          style={{ marginRight: '.5em' }}
          onClick={() => this.editProfile(node)}
        />
      </div>
    )
  };

  columnVisible = (node, detail) => {
    const { t } = this.props;
    if (node.id === ADMIN_GLOBAL_ID) return (
      <>
      <span className="p-column-title">{detail.header}</span>
      </>
    )
    if (node.estatus === StatusVisible.IS_VISIBLE) {
      return (
        <div>
          <span className="p-column-title">{detail.header}</span>
          <Button
            type="button"
            icon="pi pi-check"
            className="p-button-text"
            style={{ marginRight: '.5em' }}
            onClick={() => this.onConfirmVisible(node)}
          />
        </div>
      );
    }
    if (node.estatus === StatusVisible.IS_HIDDEN) {
      return (
        <>
          <span className="p-column-title">{detail.header}</span>
          <span className="badge-red cursor-pointer" aria-hidden="true" onClick={() => this.onConfirmVisible(node)}> {t('SUSPENDIDO')} </span>
        </>
      );
    }
    return (<span className="p-column-title">{detail.header}</span>);
  }

  columnName = (rowData, detail) => (
    <>
        <span className="p-column-title">{detail.header}</span>
        {getValueLanguageObj(rowData.nombre)}
    </>
  )

  columnResponsive = (rowData, detail) => (
    <>
        <span className="p-column-title">{detail.header}</span>
        {rowData[detail.field]}
    </>
  )

  onConfirmVisible = (data) => {
    const { t } = this.props;
    this.setState({
      showModalJustification: {
        isVisible: true,
        title: t('CONFIRMACIÓN'),
        description: t('¿Esta seguro que desea hacer este cambio?'),
        continueAction: ({justification}) => this.onChangeVisibleStatus(data, justification),
      },
    });
  };

  onChangeVisibleStatus = async (data, justification) => {
    const { t, updateStatusProfile, sendActionToBitacora } = this.props;
    const response = await updateStatusProfile({...data, justification});
    if (!response?.status) {
      const dataBitacora = {
        transactionName: data.estatus === StatusVisible.IS_VISIBLE ? 'desacPerfil' : 'activaPerfil',
        reason: `${getValueLanguageObj(data.nombre, LANGUAGE_DEFAULT)} || ${justification}`,
      }
      await sendActionToBitacora(dataBitacora)
      await this.loadData(IS_EDIT)
      this.toast.show({
        severity: 'success',
        summary: t('Confirmación'),
        detail: t('La operación se ha realizado de manera éxitosa'),
        life: 3000,
      });
    }
    return true;
  };

  onHideModal = () => {
    this.setState({
      showModalJustification: {
        isVisible: false,
      },
    });
  };

  deleteTemplate = (rowData, detail) => {
    if (rowData.id === ADMIN_GLOBAL_ID || rowData.administradores) return (
      <>
      <span className="p-column-title">{detail.header}</span>
      </>
    )
    return (
      <>
        <span className="p-column-title">{detail.header}</span>
        <Button
          icon="pi pi-trash"
          className=" p-button-text p-button-primary p-mr-2"
          onClick={() => this.onConfirmDeleteProfile(rowData)}
        />
      </>
    )
  };

  render() {
    const { t, history, validatePermissionAction } = this.props;
    const { loadingPage, profiles, loadingTable, showModalJustification } = this.state;
    if (loadingPage) return true

    const rightHeader = (
      <>
        <Button
          icon="pi pi-th-large"
          className="p-button-raised p-button-text p-button-plain"
          onClick={() => history.push('/dashboard')}
        />
        { validatePermissionAction(catalogPermissionsId.CREAR_PERFILES) && (
          <Button
            label={t('Agregar Perfil')}
            className="p-button-primary"
            onClick={() => history.push({pathname:"/profile/new", state: { clearCache: true }}) }
          />
        )}
      </>
    );

    return (
      <div className="p-grid">
        <div className="p-col-12">
          <Header title={t('Perfiles')} rightComponent={rightHeader} />
          <div className="card">
            <div className="p-col-12 p-mt-2">
              <DataTable
                value={profiles}
                lazy
                loading={loadingTable}
                className="table-bussiness"
              >
                <Column
                  header={t('Nombre')}
                  body={this.columnName}
                />
                <Column
                  header={t('Administradores asociados')}
                  field="administradores"
                  body={this.columnResponsive}
                  className="p-text-center-lg"
                />
                { validatePermissionAction(catalogPermissionsId.AJUSTAR_INFORMACION_PERFILES) && (
                  <Column
                    header={t('Editar')}
                    body={this.templateEdit}
                    className="column-action p-text-center-lg"
                  />
                )}
                <Column
                  header={t('Estatus')}
                  body={this.columnVisible}
                  className="column-max p-text-center-lg"
                />
                { validatePermissionAction(catalogPermissionsId.ELIMINAR_PERFILES) && (
                  <Column
                    header={t("Eliminar")}
                    body={this.deleteTemplate}
                    className="column-action p-text-center-lg"
                  />
                )}
              </DataTable>
            </div>
          </div>
        </div>
        <Toast ref={(el) => (this.toast = el)} />
        <JustificationModal
          display={showModalJustification.isVisible}
          title={showModalJustification.title}
          description={showModalJustification.description}
          label={showModalJustification.label}
          onHidden={() => this.onHideModal()}
          onContinueAction={showModalJustification.continueAction}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  countriesCurrentCatalog: state.catalogs.countriesCurrentCatalog,
  isFullAdmin: state.settings.isFullAdmin,
});

const mapDispatchToProps = {
  getProfilesCatalog,
  updateStatusProfile,
  deleteProfile,
  setCatalogCurrentProfiles,
  validatePermissionAction,
  sendActionToBitacora
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(Profiles);
